(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9725],{

/***/ 99725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sizeModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./components/sizeModal/SizeModal.module.scss
var SizeModal_module = __webpack_require__(59665);
var SizeModal_module_default = /*#__PURE__*/__webpack_require__.n(SizeModal_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/sizeModal/SizeModal.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var SizeTable = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9963).then(__webpack_require__.bind(__webpack_require__, 69963));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69963)];
    }
  }
});
var Html = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(6066)]).then(__webpack_require__.bind(__webpack_require__, 26066));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26066)];
    }
  }
});

var ModalTrigger = function ModalTrigger(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", _objectSpread(_objectSpread({
    className: (SizeModal_module_default()).trigger
  }, props), {}, {
    children: "\u0422\u0430\u0431\u043B\u0438\u0446\u0430 \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u0432"
  }));
};

var SizeModal = function SizeModal(_ref) {
  var data = _ref.data;

  var _ref2 = data || {},
      _ref2$table = _ref2.table,
      table = _ref2$table === void 0 ? {} : _ref2$table,
      text = _ref2.text;

  if (!table && !text) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* Modal */.u_, {
      render: ModalTrigger,
      isSizeTable: true,
      children: [table && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (SizeModal_module_default()).title,
          children: "\u0422\u0430\u0431\u043B\u0438\u0446\u0430 \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u0432"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SizeTable, {
          data: table
        })]
      }), text && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SizeModal_module_default()).modalHtml,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Html, {
          html: text
        })
      })]
    })
  });
};

/* harmony default export */ var sizeModal_SizeModal = (SizeModal);
;// CONCATENATED MODULE: ./components/sizeModal/index.js

/* harmony default export */ var sizeModal = (sizeModal_SizeModal);

/***/ }),

/***/ 59665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trigger":"SizeModal_trigger__m1b_R","title":"SizeModal_title__j5Xi7","modalHtml":"SizeModal_modalHtml__ybNV5","load":"SizeModal_load__h7Yea"};

/***/ })

}]);